<template>
	<div>
		<!-- 面包屑导航区域 -->
		<el-breadcrumb separator="/">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item><span>系统管理</span></el-breadcrumb-item>
			<el-breadcrumb-item>数据字典</el-breadcrumb-item>
		</el-breadcrumb>
		
		<!-- 卡片视图区域 -->
		<el-card class="box-card">
			<!-- 左右分栏布局 -->
			<el-container style="height: 600px;">
				<!-- 左侧字典列表 -->
				<el-aside width="300px" style="border-right: 1px solid #e6e6e6; padding-right: 15px;">
					<!-- <div style="margin-bottom: 15px;">
						<el-input v-model="dictFilterText" placeholder="输入关键字过滤" clearable size="small">
							<i slot="prefix" class="el-input__icon el-icon-search"></i>
						</el-input>
					</div> -->
					
					<el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd" style="width: 100%; margin-bottom: 15px;">新增字典</el-button>
					
					<el-table :data="filteredDictList" border stripe highlight-current-row 
						@current-change="handleCurrentDictChange" 
						:header-cell-style="{ textAlign: 'center' }"
						:cell-style="{ textAlign: 'center' }" 
						style="width: 100%; cursor: pointer;">
						<el-table-column prop="name" label="字典名称" align="left" show-overflow-tooltip>
							<template slot-scope="scope">
								<span :class="{ 'active-dict': currentDict && currentDict.id === scope.row.id }">
									{{ scope.row.name }}
								</span>
							</template>
						</el-table-column>
						<el-table-column width="120px" label="操作" align="center">
							<template slot-scope="scope">
								<el-button size="mini" type="text" @click.stop="handleUpdate(scope.row)">编辑</el-button>
								<el-button size="mini" type="text" @click.stop="handleDelete(scope.row)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-aside>
				
				<!-- 右侧字典项列表 -->
				<el-main style="padding-left: 20px;">
					<div v-if="currentDict">
						<div style="margin-bottom: 15px;">
							<span style="font-weight: bold; font-size: 16px;">{{ currentDict.name }} ({{ currentDict.code }})</span>
							<el-button type="primary" size="small" icon="el-icon-plus" @click="handleAddItem" style="float: right;">新增字典项</el-button>
						</div>
						
						<!-- 字典项表格 -->
				<el-table :data="dataDictItemList" border stripe :header-cell-style="{ textAlign: 'center' }"
					:cell-style="{ textAlign: 'center' }" style="width: 100%;">
					<el-table-column type="index" width="60" label="序号"></el-table-column>
					<el-table-column prop="k" label="键值" align="center"></el-table-column>
					<el-table-column prop="v" label="标签" align="center"></el-table-column>
					<el-table-column prop="createTime" label="创建时间" align="center" width="180"></el-table-column>
					<el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
					<el-table-column fixed="right" header-align="center" align="center" width="150" label="操作">
								<template slot-scope="scope">
									<el-button size="mini" type="primary" icon="el-icon-edit" @click="handleUpdateItem(scope.row)">修改</el-button>
									<el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDeleteItem(scope.row)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>

						<!-- 分页区域 -->
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="itemQueryParams.page"
							:page-sizes="[10, 20, 50, 100]"
							:page-size="itemQueryParams.limit"
							layout="total, sizes, prev, pager, next, jumper"
							:total="itemTotal"
							style="margin-top: 20px; text-align: right;">
						</el-pagination>
					</div>
					<div v-else style="text-align: center; padding-top: 100px; color: #909399;">
						<i class="el-icon-menu" style="font-size: 64px;"></i>
						<p style="margin-top: 20px;">请从左侧选择一个字典查看其字典项</p>
					</div>
				</el-main>
			</el-container>
		</el-card>

		<!-- 添加/修改数据字典对话框 -->
		<el-dialog :title="dictTitle" :visible.sync="dictOpen" width="500px" append-to-body>
			<el-form ref="dictForm" :model="dictForm" :rules="dictRules" label-width="80px">
				<el-form-item label="字典名称" prop="name">
					<el-input v-model="dictForm.name" placeholder="请输入字典名称" />
				</el-form-item>
				<el-form-item label="类别键值" prop="category">
					<el-input v-model="dictForm.category" placeholder="请输入类别" />
				</el-form-item>
				<el-form-item label="备注" prop="description">
					<el-input v-model="dictForm.description" type="textarea" placeholder="请输入备注" />
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelDict">取 消</el-button>
				<el-button type="primary" @click="submitDictForm">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 添加/修改数据字典项对话框 -->
		<el-dialog :title="itemTitle" :visible.sync="itemOpen" width="500px" append-to-body>
			<el-form ref="itemForm" :model="itemForm" :rules="itemRules" label-width="80px">
				<el-form-item label="字典键值" prop="k">
					<el-input v-model="itemForm.k" placeholder="请输入字典键值" />
				</el-form-item>
				<el-form-item label="字典标签" prop="v">
					<el-input v-model="itemForm.v" placeholder="请输入字典标签" />
				</el-form-item>
				<el-form-item label="排序" prop="location">
					<el-input-number v-model="itemForm.location" controls-position="right" :min="0" />
				</el-form-item>
				<el-form-item label="备注" prop="remark">
					<el-input v-model="itemForm.remark" type="textarea" placeholder="请输入备注" />
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelItem">取 消</el-button>
				<el-button type="primary" @click="submitItemForm">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "DataDict",
	data() {
		return {
			// 字典相关数据
			dataDictList: [], // 字典列表
			currentDict: null, // 当前选中的字典
			dictFilterText: '', // 字典过滤文本
			dictOpen: false, // 字典对话框显示状态
			dictTitle: '', // 字典对话框标题
			dictForm: {}, // 字典表单
			dictRules: { // 字典表单验证规则
				name: [
					{ required: true, message: "字典名称不能为空", trigger: "blur" }
				],
				code: [
					{ required: true, message: "字典编码不能为空", trigger: "blur" }
				],
				category: [
					{ required: true, message: "类别键值不能为空", trigger: "blur" }
				]
			},
			
			// 字典项相关数据
			dataDictItemList: [], // 字典项列表
			itemTotal: 0, // 字典项总数
			itemOpen: false, // 字典项对话框显示状态
			itemTitle: '', // 字典项对话框标题
			itemForm: {}, // 字典项表单
			itemRules: { // 字典项表单验证规则
				k: [
					{ required: true, message: "字典键值不能为空", trigger: "blur" }
				],
				v: [
					{ required: true, message: "字典标签不能为空", trigger: "blur" }
				]
			},
			itemQueryParams: { // 字典项查询参数
				page: 1,
				limit: 10,
				did: null,
				k: null,
				v: null
			}
		};
	},
	computed: {
		// 过滤后的字典列表
		filteredDictList() {
			if (!this.dictFilterText) {
				return this.dataDictList;
			}
			return this.dataDictList.filter(item => 
				item.name.toLowerCase().includes(this.dictFilterText.toLowerCase()) ||
				item.code.toLowerCase().includes(this.dictFilterText.toLowerCase())
			);
		}
	},
	created() {
		this.getDictList();
	},
	methods: {
		/** 查询数据字典列表 */
		getDictList() {
			this.$http.get('/system/datadict/list').then(response => {
				if (response.data.code === 200) {
					this.dataDictList = response.data.data;
					// 如果有字典列表，默认选中第一个
					if (this.dataDictList.length > 0 && !this.currentDict) {
						this.handleCurrentDictChange(this.dataDictList[0]);
					}
				} else {
					this.$message.error(response.data.msg);
				}
			});
		},
		
		/** 查询字典项列表 */
		getItemList() {
			if (!this.currentDict) return;
			
			this.itemQueryParams.did = this.currentDict.id;
			this.$http.get('/system/datadictItem/page', {
				params: this.itemQueryParams
			}).then(response => {
				if (response.data.code === 200) {
					this.dataDictItemList = response.data.data.list;
					this.itemTotal = response.data.data.total;
				} else {
					this.$message.error(response.data.msg);
				}
			});
		},
		
		/** 字典当前行变化 */
		handleCurrentDictChange(currentRow) {
			if (!currentRow) return;
			this.currentDict = currentRow;
			this.itemQueryParams.page = 1;
			this.getItemList();
		},
		
		// 字典相关方法
		/** 新增字典按钮操作 */
		handleAdd() {
			this.resetDictForm();
			this.dictOpen = true;
			this.dictTitle = "添加数据字典";
		},
		
		/** 修改字典按钮操作 */
		handleUpdate(row) {
			this.resetDictForm();
			const id = row.id;
			this.$http.get('/system/datadict/getById/' + id).then(response => {
				if (response.data.code === 200) {
					this.dictForm = response.data.data;
					this.dictOpen = true;
					this.dictTitle = "修改数据字典";
				} else {
					this.$message.error(response.data.msg);
				}
			});
		},
		
		/** 删除字典按钮操作 */
		handleDelete(row) {
			const id = row.id;
			this.$confirm('是否确认删除数据字典名称为"' + row.name + '"的数据项？', "警告", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				return this.$http.get('/system/datadict/delete/' + id);
			}).then(() => {
				this.getDictList();
				this.$message.success("删除成功");
				// 如果删除的是当前选中的字典，清空右侧
				if (this.currentDict && this.currentDict.id === id) {
					this.currentDict = null;
					this.dataDictItemList = [];
				}
			}).catch(() => {});
		},
		
		/** 提交字典表单 */
		submitDictForm() {
			this.$refs["dictForm"].validate(valid => {
				if (valid) {
					if (this.dictForm.id != null) {
						this.$http.post('/system/datadict/update', this.dictForm).then(response => {
							if (response.data.code === 200) {
								this.$message.success("修改成功");
								this.dictOpen = false;
								this.getDictList();
							} else {
								this.$message.error(response.data.msg);
							}
						});
					} else {
						this.$http.post('/system/datadict/add', this.dictForm).then(response => {
							if (response.data.code === 200) {
								this.$message.success("新增成功");
								this.dictOpen = false;
								this.getDictList();
							} else {
								this.$message.error(response.data.msg);
							}
						});
					}
				}
			});
		},
		
		/** 取消字典对话框 */
		cancelDict() {
			this.dictOpen = false;
			this.resetDictForm();
		},
		
		/** 重置字典表单 */
		resetDictForm() {
			this.dictForm = {
				id: null,
				name: null,
				code: null,
				description: null
			};
			this.$nextTick(() => {
				if (this.$refs.dictForm) {
					this.$refs.dictForm.resetFields();
					this.$refs.dictForm.clearValidate();
				}
			});
		},
		
		// 字典项相关方法
		/** 新增字典项按钮操作 */
		handleAddItem() {
			this.resetItemForm();
			this.itemOpen = true;
			this.itemTitle = `添加"${this.currentDict.name}"字典项`;
		},
		
		/** 修改字典项按钮操作 */
		handleUpdateItem(row) {
			this.resetItemForm();
			const id = row.id;
			this.$http.get('/system/datadictItem/getById/' + id).then(response => {
				if (response.data.code === 200) {
					this.itemForm = response.data.data;
					this.itemOpen = true;
					this.itemTitle = `修改"${this.currentDict.name}"字典项`;
				} else {
					this.$message.error(response.data.msg);
				}
			});
		},
		
		/** 删除字典项按钮操作 */
		handleDeleteItem(row) {
			const id = row.id;
			this.$confirm('是否确认删除字典项名称为"' + row.v + '"的数据项？', "警告", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				return this.$http.get('/system/datadictItem/delete/' + id);
			}).then(() => {
				this.getItemList();
				this.$message.success("删除成功");
			}).catch(() => {});
		},
		
		/** 提交字典项表单 */
		submitItemForm() {
			this.$refs["itemForm"].validate(valid => {
				if (valid) {
					this.itemForm.did = this.currentDict.id;
					if (this.itemForm.id != null) {
						this.$http.post('/system/datadictItem/update', this.itemForm).then(response => {
							if (response.data.code === 200) {
								this.$message.success("修改成功");
								this.itemOpen = false;
								this.getItemList();
							} else {
								this.$message.error(response.data.msg);
							}
						});
					} else {
						this.$http.post('/system/datadictItem/add', this.itemForm).then(response => {
							if (response.data.code === 200) {
								this.$message.success("新增成功");
								this.itemOpen = false;
								this.getItemList();
							} else {
								this.$message.error(response.data.msg);
							}
						});
					}
				}
			});
		},
		
		/** 取消字典项对话框 */
		cancelItem() {
			this.itemOpen = false;
			this.resetItemForm();
		},
		
		/** 重置字典项表单 */
		resetItemForm() {
			this.itemForm = {
				id: null,
				did: this.currentDict ? this.currentDict.id : null,
				k: null,
				v: null,
				location: 0,
				remark: null
			};
			this.$nextTick(() => {
				if (this.$refs.itemForm) {
					this.$refs.itemForm.resetFields();
					this.$refs.itemForm.clearValidate();
				}
			});
		},
		
		// 分页相关方法
		handleSizeChange(val) {
			this.itemQueryParams.limit = val;
			this.getItemList();
		},
		handleCurrentChange(val) {
			this.itemQueryParams.page = val;
			this.getItemList();
		}
	}
};
</script>

<style scoped>
.demo-form-inline {
	margin-bottom: 20px;
}
.el-pagination {
	margin-top: 20px;
	text-align: right;
}
.box-card {
	margin-top: 15px;
}

.dict-container {
	height: calc(100vh - 200px);
}

.aside-container {
	height: 100%;
	border-right: 1px solid #e6e6e6;
	padding-right: 15px;
}

.main-container {
	height: 100%;
	padding-left: 15px;
}

.dict-filter {
	margin-bottom: 15px;
}

.dict-table {
	height: calc(100% - 60px);
}

.dict-item-header {
	margin-bottom: 15px;
	padding-bottom: 10px;
	border-bottom: 1px solid #e6e6e6;
}

.dict-item-info {
	display: flex;
	align-items: center;
}

.dict-item-info .info-item {
	margin-right: 20px;
}

.dict-item-info .info-label {
	font-weight: bold;
	margin-right: 5px;
}

.pagination-container {
	margin-top: 15px;
	text-align: right;
}
</style>